



















import HostPageLinkMixin from '@/mixin/HostPageLink'
import ForgotPasswordImageLink from '@spa/components/pages/auth/signup/shared/forgot-password/ImageLink.vue'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component({
  components: {
    ForgotPasswordLink: ForgotPasswordImageLink,
  },
  mixins: [
    HostPageLinkMixin,
  ],
})
export default class CartLoginMyColorNote extends Vue {}
